import { render, staticRenderFns } from "./GenericBarChart.vue?vue&type=template&id=35386154"
import script from "./GenericBarChart.vue?vue&type=script&lang=ts"
export * from "./GenericBarChart.vue?vue&type=script&lang=ts"
import style0 from "./GenericBarChart.vue?vue&type=style&index=0&id=35386154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports